import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Grid, Paper, Typography } from '@material-ui/core';

import { ArchivalCollection as ArchivalCollectionType } from 'types';
import { ReadOnlyField } from 'components/read-only-field/read-only-field';
import { RegisterField } from 'modules/register/register-field';
import { handleOriginatorLink } from 'modules/register/reqister-utils';
import { useEadTreeContext } from 'components/grid/grid-ctx/EadTreeCtx';
import { Loader } from 'components/loader/loader';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
    },
    paper: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      padding: theme.spacing(2),
    },
  })
);

export function ArchivalCollectionDetail({
  item,
}: {
  item?: ArchivalCollectionType;
}) {
  const classes = useStyles();
  const { loading } = useEadTreeContext();

  const {
    name,
    evidenceNumber,
    mark,
    timeRange,
    groups = [],
    accessibility,
    languages = [],
    sumQuantity,
    processedQuantity,
    inventoriedQuantity,
    thematicDescription,
    updated,
    originators = [],
    placesOfOrigin = [],
  } = item || {};
  if (loading) {
    return <Loader />;
  }
  if (!item) {
    return <></>;
  }
  return (
    <>
      <Typography variant="h5">{name}</Typography>
      <Paper elevation={0} className={classes.paper}>
        <Grid container className={classes.root}>
          <ReadOnlyField label="Název:" value={name} />
          <ReadOnlyField label="Číslo ev. listu NAD:" value={evidenceNumber} />
          <ReadOnlyField label="Značka:" value={mark} />
          <ReadOnlyField label="Časový rozsah:" value={timeRange} />
          <ReadOnlyField label="Věcná skupina:" value={groups.join(', ')} />
          <ReadOnlyField label="Přístupnost:" value={accessibility} />
          <ReadOnlyField label="Jazyky:" value={languages.join(', ')} />
          <ReadOnlyField label="Metráž:" value={sumQuantity} />
          <ReadOnlyField label="Z toho zpracováno:" value={processedQuantity} />
          <ReadOnlyField
            label="Z toho inventarizováno:"
            value={inventoriedQuantity}
          />
          <ReadOnlyField label="Tématický popis:" value={thematicDescription} />
          <ReadOnlyField
            label="Poslední aktualizace:"
            value={updated ? new Date(updated).toLocaleString('cs') : ''}
          />
        </Grid>
      </Paper>
      <Paper elevation={0} className={classes.paper}>
        <Grid container className={classes.root}>
          <Typography variant="h6">Rejstříková hesla</Typography>
          <br />
          <br />
          {originators.map((o, i) => (
            <RegisterField
              key={o?.id}
              label={i === 0 ? 'Původce fondu:' : ''}
              withoutBorder={true}
              value={o?.preferredName?.label}
              valueLink={o && handleOriginatorLink(o, true)}
            />
          ))}
          {placesOfOrigin.map((o, i) => (
            <RegisterField
              key={o?.id}
              label={i === 0 ? 'Místo vzniku:' : ''}
              withoutBorder={true}
              value={o?.preferredName?.label}
              valueLink={o && handleOriginatorLink(o, true)}
            />
          ))}
        </Grid>
      </Paper>
    </>
  );
}
